import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-9SN7CWW103';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Only track if user has accepted cookies
    const consent = localStorage.getItem('cookie-consent');
    if (consent !== 'accepted') return;

    // Ensure gtag is available
    if (typeof window.gtag !== 'function') return;

    // Send page view
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location]);
};

// Helper function to track custom events
export const trackEvent = (
  eventName: string,
  eventParams?: Record<string, unknown>
) => {
  const consent = localStorage.getItem('cookie-consent');
  if (consent !== 'accepted') return;
  
  if (typeof window.gtag !== 'function') return;

  window.gtag('event', eventName, eventParams);
};

// Helper for e-commerce purchase tracking
export const trackPurchase = (
  transactionId: string,
  value: number,
  items: Array<{
    item_id: string;
    item_name: string;
    price: number;
    quantity: number;
  }>
) => {
  trackEvent('purchase', {
    transaction_id: transactionId,
    value: value,
    currency: 'DKK',
    items: items,
  });
};
